import { Fragment } from 'react';
import Enllac from 'components/3catinfo/Enllac';
import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatNoticiaAutor.module.scss';

const DestacatNoticiaAutor = (props) => {
    const { item, routePath, marcatgeAudienciesClick } = props;
    const { id, titol, permatitle, tipologia, autors, lloc, domini } = item;
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath, domini };

    const getImatge = (imatges, alt, hasImatges) => {
        return hasImatges ? (
            <div className={styles.autorFoto}>
                <span>
                    <Imatge
                        imatges={imatges}
                        alt={alt}
                        tipus='web_autor'
                        layout='fill'
                        objectFit='cover'
                        mostarRecursTitol={false}
                    />
                </span>
            </div>
        ) : (
            <div className={styles.autorFotoDefault}>
                <span>
                    <Imatge
                        src='/_resources/imatges/3catinfo/autor.png'
                        tipus='web_autor'
                        alt={alt}
                        layout='fill'
                        mostrarRecursTitol={false}
                        mostrarRecurs={false}
                    />
                </span>
            </div>
        );
    };
    return (
        <article>
            <div className={styles.cos}>
                <div className={styles.imatgesAutors}>
                    {!__isEmpty(autors) &&
                        autors?.map((autor, i) => {
                            if (i < 2) {
                                const autorNom = autor?.nom;
                                const autorImatgeAlt = autor.imatges ? autorNom : '';
                                const hasImatges = hasImatge(autor.imatges, 'web_autor', null, null);
                                return (
                                    <Enllac
                                        key={`enllac-img-autor-${autor?.id}`}
                                        route={route}
                                        marcatgeAudienciesClick={marcatgeAudienciesClick}
                                    >
                                        <div className={styles.contentImatge}>
                                            {getImatge(autor.imatges, autorImatgeAlt, hasImatges)}
                                        </div>
                                    </Enllac>
                                );
                            }
                            return null;
                        })}
                    {__isEmpty(autors) && (
                        <div className={styles.contentImatge}>
                            <div className={styles.autorFoto}>
                                <span>
                                    <Imatge tipus='web_autor' layout='fill' objectFit='cover' mostarRecursTitol={false} />
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <h3 className={styles.titol}>
                    <Enllac route={route} marcatgeAudienciesClick={marcatgeAudienciesClick}>
                        <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                    </Enllac>
                </h3>
            </div>
            <div className={styles.cosAutor}>
                {!__isEmpty(autors) &&
                    autors?.map((autor, i) => {
                        const autorNom = autor?.nom;
                        const routeAutor = { slug: autorNom, id: autor?.id, tipologia: autor?.tipologia };
                        const isFirst = i > 0;
                        const isLast = i === autors.length - 1;
                        return (
                            <Fragment key={`enllac-desc-autor-${autor?.id}`}>
                                {isFirst && !isLast && ', '}
                                {autors.length > 1 && isLast && ' i '}
                                <Enllac
                                    route={routeAutor}
                                    className={styles.autor}
                                    marcatgeAudienciesClick={marcatgeAudienciesClick}
                                >
                                    {autorNom}
                                </Enllac>
                            </Fragment>
                        );
                    })}
                {lloc && <span className={styles.lloc}>{lloc}</span>}
            </div>
        </article>
    );
};

export default DestacatNoticiaAutor;
